import React from 'react';
import Table from '@/modules/common/components/Table';
import TableContainer from '@/modules/common/components/TableContainer';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Component = () => {
    return (
        <TableContainer responsive={true}>
            <Table>
                <TableHead/>
                <TableBody/>
            </Table>
        </TableContainer>
    );
};

export default Component;
